import { PromissoryNoteField } from './components/PromissoryNoteField';
import { ApprovedLoanAmountField } from './components/ApprovedLoanAmountField';
import { InterestRateField } from './components/InterestRateField';
import { InterestAccrualField } from './components/InterestAccrualField';
import { ReserveRateField } from './components/ReserveRateField';
import { GradeField } from './components/GradeField';
import { UnderwritingFeeField } from './components/UnderwritingFeeField';
import { OriginationFeeField } from './components/OriginationFeeField';
import { BrokerShareField } from './components/BrokerShareField';
import { BrokerSharePercentField } from './components/BrokerSharePercentField';
import { BrokerAdditionalField } from './components/BrokerAdditionalField';
import { BrokerAdditionalPercentField } from './components/BrokerAdditionalPercentField';
import { LiquidityField } from './components/LiquidityField';
import { ItemRow } from '../../../ItemRow/ItemRow';

/** The Loan step's fields for a Build-Rent loan. No Interest Rate Floor/Ceiling. */
export const BuildRentPanel = () => {
    return (
        <>
            <ItemRow>
                <PromissoryNoteField />
                <ApprovedLoanAmountField />
            </ItemRow>
            <ItemRow>
                <InterestRateField />
                <InterestAccrualField />
            </ItemRow>
            <ItemRow>
                <ReserveRateField />
                <GradeField />
            </ItemRow>
            <ItemRow>
                <UnderwritingFeeField />
                <OriginationFeeField />
            </ItemRow>
            <ItemRow>
                <BrokerShareField />
                <BrokerSharePercentField />
            </ItemRow>
            <ItemRow>
                <BrokerAdditionalField />
                <BrokerAdditionalPercentField />
            </ItemRow>
            <ItemRow
                columnSpan={1}
                totalTableColumns={2}
            >
                <LiquidityField />
            </ItemRow>
        </>
    );
};
